import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Activity } from './../models/activity';
import { store } from './store';
import { rescheduleTasksPayloadType, scheduleTabDataType } from '../api/types';
import { AxiosResponse } from 'axios';

export default class OrderStore {
  loadingInitial = false;
  scheduleData: scheduleTabDataType[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  getScheduleData = async () => {
    try {
      const response = await agent.workflowStatus.scheduleTabData(
        store.viewStore.activeOrder.templateId,
      );
      const workFlowMetaData = response.data;
      workFlowMetaData?.sort((a: any, b: any) => {
        return a.taskIndex - b.taskIndex;
      });
      workFlowMetaData?.forEach((eachTask: any) => {
        eachTask?.subtasks?.forEach((subTask: any) => {
          if (subTask.startSTDate === '0001-01-01T00:00:00') {
            const d = new Date(subTask.startSTDate);
            if (
              d.getFullYear() === 1 &&
              d.getMonth() === 0 &&
              d.getDate() === 1
            ) {
              subTask.startSTDate = new Date().toISOString();
            }
          }
          if (subTask.endSTDate === '0001-01-01T00:00:00') {
            const d = new Date(subTask.endSTDate);
            if (
              d.getFullYear() === 1 &&
              d.getMonth() === 0 &&
              d.getDate() === 1
            ) {
              subTask.endSTDate = new Date().toISOString();
            }
          }
        });
      });
      this.scheduleData = workFlowMetaData;
    } catch {
      toast.error('Unable to fetch data. Please try again');
    }
  };

  rescheduleSubTasks = async (
    itemId: string,
    templateId: string,
    isExtend: boolean,
    payload: rescheduleTasksPayloadType[],
  ) => {
    try {
      const response = await agent.Reschedule.rescheduleTasks(
        itemId,
        templateId,
        isExtend,
        payload,
      );
      if (response.data.includes('ReScheduled the subtasks successfully')) {
        this.getScheduleData();
      }
      runInAction(() => {
        toast.success('SubTask dates rescheduled');
      });
    } catch {
      toast.error('Reschedule failed. Please try again.');
    }
  };

  createOrder = async (order: Activity, templateId: string, _L2: string) => {
    try {
      let response: AxiosResponse<string>;
      if (_L2 === 'Delivery') {
        response = await agent.Order.createOrderDelivery(order, {
          id: order.id,
        });
      } else {
        response = await agent.Order.createOrder(order);
      }
      setTimeout(async () => {
        if (response.data?.includes('Order created successully')) {
          store.viewStore.getItemDetails({ itemId: order.id });
          await store.viewStore.getActiveOrder({ itemId: order.id });
          await agent.Reschedule.updateCreateOrder(
            store.activityStore.selectedActivity?.id,
            templateId,
          );
        }
      }, 500);
      runInAction(() => {
        store.activityStore.activityRegistry.set(order.id, order);
      });
      // toast.info(' Email Sent Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
}
